import type { SVGProps } from 'react';

export const ConfigurableDashboard = (props: SVGProps<any>) => (
  <svg
    height="32px"
    role="img"
    viewBox="0 0 24 32"
    width="24px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'configurable dashboard'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g transform="translate(-4.000000, 0.000000)">
        <g transform="translate(4.000000, 0.000000)">
          <path d="M3.37688442,8.68341709 L3.37688442,3.83356784 L2.37025126,3.83356784 C1.95054648,3.83356784 1.60981111,4.17286177 1.6080402,4.59256281 L1.6080402,29.6297487 C1.6080402,30.0507063 1.94929371,30.3919598 2.37025126,30.3919598 L21.4673367,30.3919598 C21.8882942,30.3919598 22.2295477,30.0507063 22.2295477,29.6297487 L22.1330653,4.72442211 C22.1295309,4.23137825 21.7288354,3.83356784 21.2357789,3.83356784 L9.48743719,3.83356784 L9.48743719,8.68341709 L3.37688442,8.68341709 Z M5.73105528,14.1861307 L8.45829146,14.1861307 L8.45829146,18.2994975 L5.73105528,18.2994975 L5.73105528,14.1861307 Z M18.8044221,26.7288442 L5.55417085,26.7288442 L5.55417085,25.120804 L18.7915578,25.120804 L18.8044221,26.7288442 Z M15.5883417,6.04623116 L18.2737688,6.04623116 L18.2737688,18.2994975 L15.559397,18.2994975 L15.5883417,6.04623116 Z M10.638794,12.1310553 L13.3660302,12.1310553 L13.3660302,18.2994975 L10.638794,18.2994975 L10.638794,12.1310553 Z M18.7915578,21.399799 L18.7915578,23.0078392 L5.55417085,23.0078392 L5.55417085,21.399799 L18.7915578,21.399799 Z" />
          <path
            d="M23.7411055,4.71798995 C23.7322738,3.3400973 22.6136988,2.2272659 21.2357789,2.22552764 L9.48743719,2.22552764 L9.48743719,3.83356784 L21.2196985,3.83356784 C21.4593362,3.82926668 21.6907346,3.92101661 21.8623126,4.08836563 C22.0338907,4.25571464 22.1313858,4.48475172 22.1330653,4.72442211 L22.2456281,29.6297487 C22.2456281,30.0507063 21.9043746,30.3919598 21.4834171,30.3919598 L2.37025126,30.3919598 C1.94929371,30.3919598 1.6080402,30.0507063 1.6080402,29.6297487 L1.6080402,4.59256281 C1.60981111,4.17286177 1.95054648,3.8335641 2.37025126,3.83356784 L3.37688442,3.83356784 L3.37688442,2.22552764 L2.37025126,2.22552764 C1.06245256,2.22552764 0.00177448941,3.28476533 0,4.59256281 L0,29.6297487 C0.00177159228,30.9380678 1.06193215,31.9982284 2.37025126,32 L21.4673367,32 C22.7769104,31.9982255 23.8375879,30.9361075 23.8375879,29.6265327 L23.7411055,4.71798995 Z"
            fill={props.fill}
            fillRule="nonzero"
          />
          <rect
            fill={props.fill}
            fillRule="nonzero"
            height="12.2436181"
            width="2.72723618"
            x="15.559397"
            y="6.0558794"
          />
          <rect
            fill={props.fill}
            fillRule="nonzero"
            height="6.16844221"
            width="2.72723618"
            x="10.638794"
            y="12.1310553"
          />
          <rect
            fill={props.fill}
            fillRule="nonzero"
            height="4.11336683"
            width="2.72723618"
            x="5.71819095"
            y="14.1861307"
          />
          <rect
            fill={props.fill}
            fillRule="nonzero"
            height="1.6080402"
            width="13.2341709"
            x="5.55417085"
            y="21.399799"
          />
          <rect
            fill={props.fill}
            fillRule="nonzero"
            height="1.6080402"
            width="13.2341709"
            x="5.55417085"
            y="25.1304523"
          />
          <path
            d="M3.22572864,0 L3.22572864,10.9025126 L6.55758794,8.42613065 L9.88944724,10.9025126 L9.88944724,0 L3.22572864,0 Z M8.43256281,6.96603015 L6.65407035,6.03015075 L4.87557789,6.96603015 L5.21648241,4.98492462 L3.77567839,3.58271357 L5.76643216,3.29326633 L6.65407035,1.49226131 L7.54492462,3.29326633 L9.53246231,3.58271357 L8.09487437,4.98492462 L8.43256281,6.96603015 Z"
            fill={props.fill}
            fillRule="nonzero"
          />
        </g>
        <rect height="32" width="32" x="0" y="0" />
      </g>
    </g>
  </svg>
);
